export default "__VITE_ASSET__BObPY3dy__"